module.exports = (window.__NEXT_DATA__.assetPrefix || "").replace(/\/$/, "") + "/_next/static/images/500-page-tape-1-f4f894df184a45768abe95dab3196f92.png";